import classNames from "classnames";
import {forwardRef} from "react";

import {SelectionCardContext} from "@/components/selectionCard/SelectionCard.context.ts";
import {SelectionCardProps} from "@/components/selectionCard/SelectionCard.types.ts";
import {SelectionCardOption} from "@/components/selectionCard/subComponents/SelectionCardOption/SelectionCardOption.tsx";

import styles from "./SelectionCard.module.scss";

const SelectionCardBase = forwardRef<HTMLDivElement, SelectionCardProps>(
  ({value, onChange, variant = "default", layout = "horizontal", children, className, ...rest}, ref) => {
    return (
      <SelectionCardContext.Provider value={{value, onChange}}>
        <div
          ref={ref}
          role="radiogroup"
          className={classNames(styles.selectionCard, styles[variant], styles[layout], className)}
          {...rest}
        >
          {children}
        </div>
      </SelectionCardContext.Provider>
    );
  }
);

SelectionCardBase.displayName = "SelectionCard";

export const SelectionCard = Object.assign(SelectionCardBase, {
  Option: SelectionCardOption,
});
